<template>
  <div v-if="model">
    <Modal v-model="model"  title="服务记录详情" sticky reset-drag-position :style="firstStyle" @on-cancel="cancel" scrollable footer-hide :mask="false" draggable class="service_record_detail" width="1000">
    <Spin size="small" v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>页面加载中...</div></Spin>
    <div class="split_public split_left">
      <div class="left_top">
        <div class="font_style_set">客户详情:</div>
        <div class="content">
          <label>{{customerNameField}}:</label>
          <label :title="customerName">{{customerName}}</label>
        </div>
        <div class="content">
          <label>{{customerTypeField}}:</label>
          <label :title="customerType">{{customerType}}</label>
        </div>
        <div class="content">
          <label>{{customerManagerField}}:</label>
          <label :title="customerType">{{customerManager}}</label>
        </div>
        <div class="content">
          <label>{{telephoneOneField}}:</label>
          <label :title="customerType">{{telephoneOne}}</label>
        </div>
        <div class="content">
          <label>{{nextConnectTimeField}}:</label>
          <label :title="customerType">{{nextConnectTime}}</label>
        </div>
        <div class="content_tab">
          <div style="width: 100px">
            <div class="content_top">{{callTime}}</div>
            <div class="content_down">通话时长</div>
          </div>
          <div style="width: 100px;margin-left: 50px">
            <div class="content_top">{{serviceCount}}次</div>
            <div class="content_down">通话次数</div>
          </div>
        </div>
      </div>
      <div class="left_bottom">
        <div class="content">
          <label>员工工号:</label>
          <label :title="agentNumber">{{agentNumber}}</label>
        </div>
        <div class="content">
          <label>员工姓名:</label>
          <label :title="employeeName">{{employeeName}}</label>
        </div>
        <div class="content">
          <label>员工分机:</label>
          <label>{{agentExten}}</label>
        </div>
        <div class="content">
          <label>员工手机:</label>
          <label :title="employeeMobile">{{employeeMobile}}</label>
        </div>
      </div>
    </div>
    <div class="split_public split_right">
      <audio controls="controls" ref="audio" id="autoPlayEqu" controlsList="download"></audio>
      <div class="chatBox-content-demo">
        <el-collapse v-model="activeNames">
          <el-collapse-item title="服务信息" name="1" >
            <div class="chatBox_div left " v-for="(item,index) in serviceList" :key="index" style="margin-bottom:10px;">
                <div class="font_style_set" :title="item.name">{{item.name}}:</div>
                <div class="chatBox_content">{{item.value}}</div>
            </div>
            <div v-for="(item,index) in otherList" :key= "index+10" class="chatBox_div left " style="display: inline-block;width: 98%;min-height:30px;height:auto;position: relative;margin-bottom: 10px;">
                <div class="font_style_set" style="width: 17%; padding-left: 5px;min-height:30px;height:100%;position: absolute;display:flex;align-items: center;" :title="item.name">
                    {{item.name}}:
                </div>
                <div v-if = "item.type != 'file'" class="chatBox_content" style = "height:auto;margin-left: 17%;width: 83%;">{{item.value}}</div>
                <div v-else class="chatBox_content" style = "height:auto;margin-left: 17%;width: 83%;">
                  <p v-for="(fileItem,fileIndex) in JSON.parse(item.value)" :key = "fileIndex">
                    <a style="font-size:14px;" :href="baseURL+'common/downloadFile.json?type=0&addr='+fileItem.downloadAddr">附件{{fileIndex+1}}：{{fileItem.description}}</a>
                  </p>
                </div>
                <div style="clear:both;"></div>
            </div>

          </el-collapse-item>
          <el-collapse-item title="通话信息" name="2">
            <div class="chatBox_div left">
              <div class="font_style_set">主叫号:</div>
              <div class="chatBox_content">{{callerNum}}</div>
            </div>
            <div class="chatBox_div right">
              <div class="font_style_set">被叫号:</div>
              <div class="chatBox_content">{{calleeNum}}</div>
            </div>
            <div class="chatBox_div left">
              <div class="font_style_set">通话状态:</div>
              <div class="chatBox_content">{{callState}}</div>
            </div>
            <div class="chatBox_div right">
              <div class="font_style_set">部门名称:</div>
              <div class="chatBox_content">{{agentDeptName}}</div>
            </div>
            <div class="chatBox_div left">
              <div class="font_style_set">呼叫类型:</div>
              <div class="chatBox_content">{{callType}}</div>
            </div>
            <div class="chatBox_div right">
              <div class="font_style_set">满意度:</div>
              <div class="chatBox_content">{{grade}}</div>
            </div>
            <div class="chatBox_div left">
              <div class="font_style_set">热线号码:</div>
              <div class="chatBox_content">{{pstnNumber}}</div>
            </div>
            <div class="chatBox_div right">
              <div class="font_style_set">开始时间:</div>
              <div class="chatBox_content">{{startTime}}</div>
            </div>
            <div class="chatBox_div left">
              <div class="font_style_set">IVR时长:</div>
              <div class="chatBox_content">{{IVR}}秒</div>
            </div>
            <div class="chatBox_div right">
              <div class="font_style_set">总时长:</div>
              <div class="chatBox_content">{{allTime}}</div>
            </div>
            <div class="chatBox_div" style="width: 98%;margin-left: 1%;float: left;margin-bottom: 15px;">
              <div class="font_style_set" style="width: 17.24%">挂机原因:</div>
              <div class="chatBox_content" style="width: 82.76%">{{custHangup}}</div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </Modal>
  </div>
</template>

<script>
     import {publicFunClass} from '@/components/js/PublicFunClass.js'
    export default {
      name: "ServiceRecordDetailPop",
      mixins:[publicFunClass],
      props: {
        showServiceRecordDetail:Boolean,
        recordId:String
      },
      data(){
        return {
          firstStyle:{top:'',left:''},
          model:false,
          spinShow:true,
          always:true,
          activeNames:['1','2'],
          configInfo: JSON.parse(localStorage.getItem("configInfo")),
          serviceList:[],  //服务记录字段，不是文本域或附件的
          otherList:[],  //服务记录字段，包含文本域和附件字段
          customerName:'',
          telephoneOne:'',
          serviceCount:'',
          agentNumber:'',
          customerType:'',
          nextConnectTime:'',
          customerManager:'',
          employeeMobile:'',
          agentExten:'',
          employeeName:'',
          serviceDescr:'',
          serviceDescrName:'',
          calleeNum:'',
          callerNum:'',
          callType:'',
          custHangup:'',
          grade:'',
          agentDeptName:'',
          recordFile:'',
          callState:'',
          pstnNumber:'',
          startTime:'',
          IVR:'',
          allTime:'',
          callTime:'',
          customerNameField:'',
          customerTypeField:'',
          customerManagerField:'',
          telephoneOneField:'',
          nextConnectTimeField:'',
        }
      },
      methods: {
        cancel: function () {
          this.$emit("closeServiceRecordDetail",false);
        },
        initSearch:function () {
          let that=this;
          this.spinShow=true;
          let param={
            id:this.recordId,
            customerScope:this.customerScope,
            journalType:"null",
            menuId:"null",
            selectCount:false,
            pageNum:1,
            pageSize:10
          };
          this.$http.post("service/getServiceDetail.json",param) .then(function (res) {
            that.spinShow=false;
            let result=res.data.flag;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            //客户模块
            let customerList=res.data.obj.customerList;
            let phoneIsHide= that.configInfo.phoneIsHide;
            //号码显示归属地
            let phoneIsAddress = that.configInfo.phoneOwnership;
            if(customerList.length>0){
              that.customerName=customerList[0].customerName;
              that.telephoneOne=customerList[0].telephoneOne;
              if("1"==phoneIsHide){
                that.telephoneOne=customerList[0].telephoneOneHide;
              }
              that.customerType=customerList[0].customerType;
              that.nextConnectTime=customerList[0].nextConnectTime;
              that.customerManager=customerList[0].customerManager;
            }
            //员工模块
            let employeeList=res.data.obj.employeeList;
            if(employeeList.length>0){
              that.agentNumber=employeeList[0].agentNumber;
              that.employeeName=employeeList[0].employeeName;
              that.agentExten=employeeList[0].agentExten;
              that.employeeMobile=employeeList[0].employeeMobile;
            }
            //通话次数
            that.serviceCount=res.data.obj.serviceCount;
            //通话详情
            let callLegList=res.data.obj.callList;
            if(callLegList.length>0){
              that.calleeNum=callLegList[0].calleeNum;
              that.callerNum=callLegList[0].callerNum;
              that.grade=callLegList[0].grade;
              that.callType=callLegList[0].callType;
              that.custHangup=callLegList[0].custHangup;
              that.agentDeptName=callLegList[0].agentDeptName;
              that.$refs.audio.src=that.baseImgURL+callLegList[0].recordFile;
              that.callState=callLegList[0].callState;
              that.pstnNumber=callLegList[0].pstnNumber;
              that.startTime=callLegList[0].startTime;
              that.IVR=callLegList[0].IVR;
              that.allTime=callLegList[0].allTime;
              that.callTime=callLegList[0].callTime;
            }
            //服务模块
            let serviceArray=res.data.obj.serviceList;
            that.serviceList=[];
            that.otherList=[];

            let filedList = res.data.obj.fields;

              for(let k = 0; k < filedList.length; k++){
                let colName = filedList[k].customColName;
                let isUse = filedList[k].customIsUse;
                let customType = filedList[k].customType;
                if (isUse == "1"){ //启用
                   if (customType == "textarea" || customType == "file"){  //文本域或文件
                      if(!serviceArray[0][colName]){
                        if(customType == "file" ){
                          serviceArray[0][colName] = "[]";
                        }else{
                          serviceArray[0][colName] = "";
                        }
                      }
                     that.otherList.push({name:filedList[k].customName, value: serviceArray[0][colName], type: customType});
                   }else{
                     let value = serviceArray[0][colName+"Hide"];
                     if(phoneIsHide == "1" && colName.indexOf("telephone") > -1){  //隐藏号码
                       if('1' == phoneIsAddress){
                         if(serviceArray[0][colName+"Address"]){
                          value = value +"("+serviceArray[0][colName+"Address"]+")";
                         }
                       }
                       that.serviceList.push({name:filedList[k].customName, value: value, type: customType});
                     }else{
                       let value = serviceArray[0][colName];
                         if('1' == phoneIsAddress && colName.indexOf("telephone") > -1){
                           if(serviceArray[0][colName+"Address"]){
                            value = value +"("+serviceArray[0][colName+"Address"]+")";
                           }
                         }
                        if(colName == 'employeeId'){
                          colName = "employeeName";
                        }
                        if(colName == 'customerId'){
                          colName = "customerName";
                        }
                        that.serviceList.push({name:filedList[k].customName, value: value});
                     }
                   }
                }
              }
          });
        },
        reset:function () {
          this.serviceList=[];
          this.otherList=[];
          this.customerName="";
          this.telephoneOne="";
          this.serviceCount="";
          this.agentNumber="";
          this.customerType="";
          this.nextConnectTime="";
          this.customerManager="";
          this.employeeMobile="";
          this.agentExten="";
          this.employeeName="";
          this.serviceDescr="";
          this.serviceDescrName="";
          this.calleeNum="";
          this.callerNum="";
          this.callType="";
          this.custHangup="";
          this.grade="";
          this.agentDeptName="";
          this.recordFile="";
          this.callState="";
          this.pstnNumber="";
          this.startTime="";
          this.IVR="";
          this.allTime="";
          this.callTime="";
        },
        getFields: function(){
          let that=this;
          let param={
            moduleId: "1",
            pageNum:0,
            pageSize:0
          };
          this.$http.post("custom/fields.json",param) .then(function (res) {
            let result=res.data.flag;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            let fields = res.data.obj.list.content;
            that.customerNameField = fields.find(item => item.customColName == 'customerName').customName;
            that.customerManagerField = fields.find(item => item.customColName == 'customerManager').customName;
            that.customerTypeField = fields.find(item => item.customColName == 'customerType').customName;
            that.telephoneOneField = fields.find(item => item.customColName == 'telephoneOne').customName;
            that.nextConnectTimeField = fields.find(item => item.customColName == 'nextConnectTime').customName;
          });
        }
      },
      created() {
        this.firstStyle.left = "20%";
        this.firstStyle.top = "10%";
      },
      watch:{
        showServiceRecordDetail:function () {
          this.model=this.showServiceRecordDetail;
          if(this.showServiceRecordDetail){
            this.reset();
            this.getFields();
            this.initSearch();
          }
          if(!this.showServiceRecordDetail){
            document.getElementById("autoPlayEqu").pause();
            document.getElementById("autoPlayEqu").currentTime=0;
          }
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/customerMange/ServiceRecordDetailPop.vue